import './BackToTopButton.css';

interface BackToTopButtonProps {
  show: boolean;
  onClick: () => void;
}

export default function BackToTopButton({ show, onClick }: BackToTopButtonProps) {

  return (
    <a
      href="#section1"
      id="top"
      className={show ? 'show' : ''}
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
    >
      ^
    </a>
  );
}
